export default __webpack_public_path__ + "static/media/icon-PreparingShipment.c910fa94.svg";